import React from "react";
import "./css/navbar.css";
import { ImCross } from "react-icons/im";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';


function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const items = [
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
        
        </a>
      ),
      key: '0',
    }, {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
         
        </a>
      ),
      key: '0',
    },
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
         
        </a>
      ),
      key: '0',
    },
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
         
        </a>
      ),
      key: '0',
    },
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://lab.yourgutmap.co.uk/">
          Patient Microbiome Login
        </a>
      ),
      key: '0',
    },
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://lab.yourgutmap.co.uk/practitioner">
          Practitioner Microbiome Login
        </a>
      ),
      key: '1',
    },
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://portal.yourgutmap.co.uk/">
         GutMapDx Portal Login
        </a>
      ),
      key: '2',
    },
  ];
  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 45); // Change this value as needed
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
    useEffect(() => {
    if (isScrolled) {
      document.body.classList.add("scrolled-body");
    } else {
      document.body.classList.remove("scrolled-body");
    }
  }, [isScrolled]);
  return (
    <div className="main-navbar" >
      <div className="navtop">
        <div className="navtop-text">FREE SHIPPING ON UK ORDERS</div>
        <div className="anchor-tags">
        {/* <div className="login-area">Login
          <svg
          className="mysvg"
            width="12px"
            height="12px"
            viewBox="-32 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" />
          </svg>
        </div> */}
        <Dropdown
  menu={{ items: items }}
  placement="bottomRight"
  trigger={['click']}
  dropdownStyle={{ marginTop: '550px' }} // ✅ custom offset
  popupClassName="custom-login-dropdown"
  getPopupContainer={() => document.getElementById('navbar')} 
>
  <div className="login-area">
    Login
    <svg
      className="mysvg"
      width="12px"
      height="12px"
      viewBox="-32 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" />
    </svg>
  </div>
</Dropdown>

        <div className="cart-area">
        <Link to="https://yourgutmap.co.uk/cart">Cart
        <svg 
        className="mysvg"
        width="15px"
        height="15px"
        // class="e-font-icon-svg e-eicon-bag-medium"
         viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg"><path d="M323 292L323 207C329 95 391 33 501 33 610 33 673 95 677 209V292H750C796 292 833 329 833 375V875C833 921 796 958 750 958H250C204 958 167 921 167 875V375C167 329 204 292 250 292H323ZM385 292H615L615 210C611 130 577 95 501 95 425 95 390 130 385 209L385 292ZM323 354H250C238 354 229 363 229 375V875C229 887 238 896 250 896H750C762 896 771 887 771 875V375C771 363 762 354 750 354H677V454C677 471 663 485 646 485S615 471 615 454L615 354H385L385 454C385 471 371 485 354 485 337 485 323 471 323 454L323 354Z"></path></svg>
        </Link>
        </div>
        </div>
      </div>
      <div className={`navbar ${isScrolled ? "fixed-navbar" : ""}`}>
        <div className="logo">
          <img
            // src="https://yourgutmap.co.uk/wp-content/uploads/2023/03/ygm-logo.png"
            src='/GutMapDxLogo.png'
            alt=""
          />
        </div>

        <input id="navbarcheckbox" type="checkbox" />

        <label for="navbarcheckbox" className="navbaricons open">
          <FaBars style={{ width: "30px", height: "30px" }} />
        </label>
        <label for="navbarcheckbox" className="navbaricons close">
          <ImCross style={{ width: "30px", height: "30px" }} />
        </label>

        <div className="bar">
          <a href="https://yourgutmap.co.uk/">Home</a>

          <div className="aboutlist">
            <a href="https://yourgutmap.co.uk/about/">About</a>
          </div>
          <a href="https://yourgutmap.co.uk/practitioners/">Practitioners</a>
          <a href="https://yourgutmap.co.uk/charity/">Charity</a>
          <a href="https://yourgutmap.co.uk/events/?v=1cd3c693132f/">Events</a>
          <a href="https://academy.yourgutmap.co.uk/">Academy</a>
          {/* <a href='https://yourgutmap.co.uk/shop/'> <button className='no-underline'>Shop</button></a> */}
          <a href="https://yourgutmap.co.uk/shop/" className="no-underline">
            <button>Shop</button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
